/*eslint react-hooks/exhaustive-deps: "off"*/
import { Button } from 'primereact/button';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import useProcessRules from 'src/hooks/useProcessRules';
import { setNombresArchivosSubir } from 'src/reducers/PaginaCompra/actions';
import { uploadFile } from 'src/services/Files.service';
import uuid from 'uuid';
import CustomErrorMessage from './CustomErrorMessage';
import { useDispatch, useSelector } from 'react-redux'
import useCustomToast from 'src/hooks/useCustomToast';

const fileStates = {
  uploading: 'SUBIENDO ARCHIVO',
  error: 'HA OCURRIDO UN PROBLEMA',
  completed: 'SE HA SUBIDO CORRECTAMENTE',
};

const InputFile = ({ input }) => {

  const dispatch = useDispatch();
  const methods = useFormContext();
  const { addErrorToast } = useCustomToast()

  const archivosSubidos = useSelector<any>((state) => state?.NombresArchivosSubir) as Array<any>;

  const { watch, clearErrors } = methods;

  input.value = watch(input.name);

  const [uploadState, setUploadState] = useState('');

  const { processValidations, setLoading } = useProcessRules(input);

  const [rules, setRules] = useState<any>({});

  const validation = async (value) => {
    if (value === fileStates.uploading) {
      return 'Por favor esperar hasta que el archivo termine de cargarse';
    }
    return true;
  };

  useEffect(() => {
    const rules = processValidations();
    setRules({
      ...input?.rules,
      validate: {
        ...rules?.validate?.custom,
        validate: validation,
      },
    });
  }, []);

  function toBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  const onSelectFile = (setValue) => async (event) => {
    try {
      let archivo = event.target.files[0];
      if (archivosSubidos.findIndex(x => x === archivo.name) > -1) {
        addErrorToast('El archivo ya se encuentra subido')
        return
      }
      setValue(fileStates.uploading);
      setLoading(true);
      setUploadState(fileStates.uploading);
      dispatch(setNombresArchivosSubir(archivo.name));

      const tipo = archivo.type.split('/')[1];
      archivo = await toBase64(archivo);
      const ind = archivo.indexOf(',');
      archivo = archivo.substring(ind + 1);
      const cedula = uuid.v4();

      const body = { archivo, tipo, cedula };

      const {
        status,
        data: { transaccion, data },
      } = await uploadFile(body);

      if (status === 200 && transaccion) {
        setValue(data.url);
        clearErrors(input.name);
        input.value = data.url;
      }
      setLoading(false);
      setUploadState(fileStates.completed);
    } catch (error) {
      setLoading(false);
      setValue('');
      console.log(error);
    }
  };

  return (
    <div>
      <Controller
        name={input.name}
        control={methods.control}
        rules={rules}
        defaultValue={null}
        render={({ field: { onChange, value } }) => (
          <React.Fragment>
            <label className="d-inline" htmlFor="">
              {input.label}
              {rules?.required && ' *'}
            </label>
            <p />
            {uploadState === fileStates.completed && <p className="text-primary">{uploadState}</p>}
            {uploadState !== fileStates.uploading && (
              <div className="p-buttonset row">
                <div className="col-6 pr-0">
                  <label htmlFor={`${input.name}`} className="text-center p-button p-component w-100 d-block h-100"
                    style={{}}><i className="pi pi-upload mr-2" style={{ marginRight: 5 }}></i> Seleccionar archivo</label>
                  <input
                    id={input.name}
                    name={input.name}
                    onChange={onSelectFile(onChange)}
                    type="file"
                    style={{ display: 'none' }}
                    accept=".png, .jpg, .jpeg, application/pdf"
                  />
                </div>
                {input?.default && (
                  <div className="col-6 pl-0">
                    <Button
                      color="inherit"
                      // component="a"
                      // target="_blank"
                      // href={input?.default}
                      onClick={() => window.open(input?.default, '_blank')}
                      label='Descargar'
                      className="p-button-info w-100 h-100"
                      icon='pi pi-download'
                      type='button'
                      style={{ borderRadius: 0, border: '1px solid #e0e0e1' }}
                    />
                  </div>
                )}
                {value && (
                  <div className="col-6">
                    <Button
                      icon='pi pi-eye'
                      color="inherit"
                      // component="a"
                      // target="_blank"
                      // href={value}
                      onClick={() => window.open(value, '_blank')}
                      className="p-button-info w-100 h-100"
                      label='Ver archivo'
                      type='button'
                      style={{ borderRadius: 0, border: '1px solid #e0e0e1' }}
                    />
                  </div>
                )}
              </div>
            )}

            {uploadState === fileStates.uploading && (
              <div>
                <p className="text-primary">{uploadState}</p>
              </div>
            )}
          </React.Fragment>
        )}
      />

      <CustomErrorMessage name={input.name} />
    </div>
  );
};

export default InputFile;
